__turbopack_context__.v({
  "clear": "search-module-scss-module__rYfoXa__clear",
  "wrapper": "search-module-scss-module__rYfoXa__wrapper",
});
